import {
  MdArrowDropUp,
  MdOutlineCalendarToday,
  MdBarChart,
} from "react-icons/md";
import Card from "components/card";
import {
  lineChartDataTotalSpent,
  lineChartOptionsTotalSpent,
} from "variables/charts";
import LineChart from "components/charts/LineChart";
import { useEffect, useState } from "react";

const TotalNotes = (props: any) => {
  const [chartColor, setChartColor] = useState("#422afb");

  useEffect(() => {
    console.log("Total Notes: ", props.data)
  }, [props.data])

  useEffect(() => {
    const updateChartColor = () => {
      const color = getComputedStyle(document.documentElement)
        .getPropertyValue("--color-brand-500")
        .trim();
      if (color) setChartColor(color);
    };

    updateChartColor();
    const observer = new MutationObserver(updateChartColor);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["style", "class"] });
    return () => observer.disconnect();
  }, []);


  const hasData = Array.isArray(props.data) && props.data.length > 0;

  const info = hasData ? [{
    name: "Notes",
    data: props.data,
    color: chartColor,
  }] : [];

  return (
    <Card extra="!p-[20px] text-center">
      <div className="flex justify-between">
        <button className="linear mt-1 flex items-center justify-center gap-2 rounded-lg bg-surfaceSecondary p-2 text-textSecondary transition duration-200 hover:cursor-pointer hover:bg-surfaceSecondary/80 active:bg-surfaceSecondary/70">
          <MdOutlineCalendarToday />
          <span className="text-sm font-medium text-textSecondary">This month</span>
        </button>
        <button className="!linear z-[1] flex items-center justify-center rounded-lg bg-surfaceSecondary p-2 text-brand-500 !transition !duration-200 hover:bg-surfaceSecondary/80 active:bg-surfaceSecondary/70">
          <MdBarChart className="h-6 w-6" />
        </button>
      </div>

      <div className="flex h-full w-full flex-row justify-between sm:flex-wrap lg:flex-nowrap 2xl:overflow-hidden">
        <div className="flex flex-col">
          <p className="mt-[20px] text-3xl font-bold text-textPrimary">
            {props.count}
          </p>
          <div className="flex flex-col items-start">
            <p className="mt-2 text-sm text-textSecondary">Total Notes</p>
          </div>
        </div>
        <div className="h-full w-full">
          {
            hasData ? <LineChart
              chartOptions={{
                ...lineChartOptionsTotalSpent,
                colors: [chartColor],
                stroke: { ...lineChartOptionsTotalSpent.stroke, colors: [chartColor] },
              }}
              chartData={info}
            /> : null
          }
        </div>
      </div>
    </Card>
  );
};

export default TotalNotes;
